module.exports = __webpack_public_path__ + "img/28_5.f1bc4ed7.png";